import React from 'react';
import { useTranslation } from 'react-i18next';

import { useCallbackRef } from '@/js/libs/hooks/useCallbackRef';
import { Button, Icons, PageHeader } from '@/js/libs/ui/src/V2';

import { ROUTER } from 'src/AppRouter';

export const Header: React.FC = React.memo(function Header() {
  const [t] = useTranslation(['backend', 'common', 'serviceDashboard']);

  const createTask = useCallbackRef(() => {
    ROUTER['/sales/tasks/create'].path.navigate();
  });

  return (
    <PageHeader
      title={t('common:TASKS')}
      actions={
        <Button primary onClick={createTask} dataTestId='create-task-button'>
          <Icons.Add alt />
          {t('serviceDashboard:CREATE_TASK')}
        </Button>
      }
    />
  );
});
